/**
 * Calculates which dot indices should be visible in the carousel indicator
 * when there are more than 4 images (sliding window of max 5 dots).
 *
 * @param currentIndex - The currently active image index
 * @param totalImages - Total number of images in the carousel
 * @returns Array of image indices to display as dots
 */
export const getVisibleDotIndices = (
  currentIndex: number,
  totalImages: number,
): number[] => {
  const maxVisibleDots = 5
  const startIndex = Math.max(
    0,
    Math.min(currentIndex - 2, totalImages - maxVisibleDots),
  )
  return Array.from({ length: Math.min(maxVisibleDots, totalImages) }).map(
    (_, i) => startIndex + i,
  )
}

/**
 * Determines the size of a dot based on its distance from the current index.
 * Used for the sliding window effect where dots further from center are smaller.
 *
 * @param dotIndex - The index of the dot
 * @param currentIndex - The currently active image index
 * @returns Size variant: 'medium', 'small', or 'smaller'
 */
export const getDotSize = (
  dotIndex: number,
  currentIndex: number,
): 'medium' | 'small' | 'smaller' => {
  const distanceFromCurrent = Math.abs(dotIndex - currentIndex)
  if (distanceFromCurrent <= 1) return 'medium'
  if (distanceFromCurrent === 2) return 'small'
  return 'smaller'
}
